import "./style.css";
import "./lesson/lesson.css";
import { LSM } from "./engine/lsm";
import { IdbStore } from "./ui/idbstore";
import { App } from "./ui/app";
import { renderLesson } from "./lesson/lesson";

// Hash routing, not path routing: the site must work unchanged from a domain
// root (Cloudflare Workers) and from a project subpath (GitLab Pages), with
// no server-side rewrite rules available on either.
const SANDBOX = "#sandbox";

let sandboxReady: Promise<void> | null = null;

async function initSandbox(): Promise<void> {
  const store = await IdbStore.open();
  // Reopening against the same store IS the crash-recovery path: the
  // memtable is gone, and open() replays the WAL.
  const reopen = () => LSM.open(store, app.db.config);
  const engine = await LSM.open(store);
  const app: App = new App(engine, reopen);
}

function route(): void {
  const sandbox = location.hash === SANDBOX;
  document.getElementById("view-lesson")!.hidden = sandbox;
  document.getElementById("view-sandbox")!.hidden = !sandbox;
  document.body.classList.toggle("in-sandbox", sandbox);
  if (sandbox) {
    // The sandbox opens IndexedDB, so only pay for it if the reader asks.
    sandboxReady ??= initSandbox().catch((err) => {
      console.error(err);
      document.getElementById("view-sandbox")!.textContent =
        "failed to start the engine: " + err;
    });
  } else {
    window.scrollTo({ top: 0 });
  }
}

function boot(): void {
  renderLesson(document.getElementById("view-lesson")!, () => {
    location.hash = SANDBOX;
  });
  document.getElementById("back-to-lesson")!.onclick = () => {
    location.hash = "";
  };
  window.addEventListener("hashchange", route);
  route();
}

boot();
